import { connect } from "react-redux";

var LoadingButton = require("components/utility/LoadingButton");
var StudentsSelectedDisplay = require("components/org/roster/StudentsSelectedDisplay");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var StandardIcon = require("components/utility/icons/StandardIcon");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

@connect(
	(state, props) => ({
		totalStudents: RosterSelectors.students({ state }).length
	}),
	(dispatch, props) => ({
		createAward: (award) => {
			return dispatch(RosterActions.createAward({ award }))
		}
	})
)
class AwardCoins extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false, showCustomCoinsInput: false
		};
	}

	awardCoins(e) {
		$wr.nope(e)
		this.refs.errors.reset();
		var errors = [];
		if (!this.state.loading) {
			this.setState({ loading: true });
			var coinsAmount = this.refs.coinsAmount.value;
			var coinsReason = this.refs.coinsReason.value;

			if (coinsAmount == 0) {
				errors.push("Please select an amount of coins to award.");
			} else if (coinsReason == 0) {
				errors.push("Please enter a reason for awarding the coins.");
			}

			if (errors.length == 0) {
				var title = "Coins Awarded"
				var text = "You awarded " + coinsAmount + " coins."
				var studentIds = _.pluck(this.props.students, "id");
				var award = { type: "coins", amount: coinsAmount, reason: coinsReason, student_ids: studentIds };
	
				this.props.createAward(award).then(() => {
					this.setState({ loading: false });

					window.wrNotifications.triggerDropDownNotification({
						title: title, text: text, icon: "ok-circle", duration: 4000 });
						
					if (this.props.onComplete) {
						this.props.onComplete()
					}
				})

			} else {
				this.setState({ loading: false });
				this.refs.errors.setErrors(errors);
			}
		}
	}

	toggleCustomCoins() {
		if (this.state.showCustomCoinsInput) {
			this.setState({ showCustomCoinsInput: false });
		} else {
			this.setState({ showCustomCoinsInput: true });
		}
	}

	render() {
		if (this.state.showCustomCoinsInput) {
			var coinsAmount = (
				<input type="number" className="form-control selectCoins" ref="coinsAmount" 
					placeholder="Enter Amount"/>
			)
		} else {
			var coinsAmount = (
				<select name="coinsAmount" className="selectCoins form-control"
					ref="coinsAmount"> 
					<option value="">Select amount</option>	
					<option value="25">25 - Good Job</option>
					<option value="50">50 - Great Work</option>
					<option value="75">75 - Fantastic</option>
					<option value="100">100 - Amazing</option>
					<option value="200">200 - Woohoo!</option>
				</select>	
			)
		}

		return (
			<div className="awardCoins">
				<StudentsSelectedDisplay totalStudents={ this.props.totalStudents } studentsSelected={ this.props.students } />

				<form onSubmit={ this.awardCoins }>
					<ErrorDisplay ref="errors" />
					<div className="awardCoinsAmountSection">
						<p className="coinsInputTitle">Amount</p>
						<StandardIcon icon="coin" type={ StandardIcon.WR_ICON } className="iconImage" />
						{ coinsAmount }
						<label>
							<input type="checkbox" checked={ this.state.showCustomCoinsInput }
								onChange={ this.toggleCustomCoins } />
							Award Custom Amount
						</label>
					</div>
					<div className="awardCoinsInputSection">
						<p className="coinsInputTitle">Reason</p>
						<input className="form-control coinsReason" ref="coinsReason" placeholder="Ex: Class participation or Homework">		
						</input>
					</div>
					<LoadingButton className="buttonSuccess center-block" text="Award Coins" loading={ this.state.loading } />	
				</form>
			</div>
		);
	}
};

AwardCoins.WrappedComponent.propTypes = StrictPropTypes({
	// From above
	students: PropTypes.array,
	onComplete: PropTypes.func,
	
	// Data from @connect
	totalStudents: PropTypes.number,
	
	// Handler from @connect
	createAward: PropTypes.func
});

module.exports = AwardCoins;


// WEBPACK FOOTER //
// ./modules/components/org/roster/AwardCoins.js